import React, { useState, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import useUserPermissions from '../../../hooks/useUserPermissions';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useContext(AuthContext);
  const { isAdmin, canAccessDashboard } = useUserPermissions();
  const navigate = useNavigate();

  const menuItems = [
    {
      path: '/wallets',
      icon: '👛',
      label: 'Wallets',
      permission: canAccessDashboard
    },
    {
      type: 'divider'
    },
    {
      path: '/grid',
      icon: '📊',
      label: 'GridBot',
      permission: canAccessDashboard
    },
    {
      path: '/sniper',
      icon: '🐋',
      label: 'Sniper',
      permission: canAccessDashboard
    },
    {
      path: '/futures',
      icon: '⚡',
      label: 'Futures',
      permission: canAccessDashboard
    },
    {
      type: 'divider'
    },
    {
      path: '/ListadoUsuarios',
      icon: '👥',
      label: 'Users',
      permission: isAdmin && user?.menu_usuarios
    },
    {
      path: '/admin',
      icon: '⚙️',
      label: 'Admin',
      permission: isAdmin && user?.menu_admin
    }
  ];

  const handleLogout = () => {
    navigate('/logout');
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      {/* Backdrop for mobile */}
      {isOpen && (
        <div 
          className="sidebar-backdrop show" 
          onClick={onClose}
        />
      )}

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="sidebar-header">
          <div className="logo">
            {!collapsed && <span className="logo-text">JoGa Bot</span>}
            <img 
              src="/LogoSistemify2RS.png" 
              alt="Logo" 
              className="logo-img" 
            />
          </div>
          <button 
            className="collapse-btn"
            onClick={toggleCollapse}
            aria-label="Toggle Sidebar"
            title={collapsed ? 'Expandir' : 'Contraer'}
          >
            {collapsed ? '→' : '←'}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {menuItems.map((item, index) => {
            if (item.type === 'divider') {
              return <div key={`divider-${index}`} className="nav-divider" />;
            }

            if (!item.permission) return null;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => 
                  `nav-item ${isActive ? 'active' : ''}`
                }
                title={collapsed ? item.label : ''}
                onClick={() => {
                  // Cerrar sidebar en mobile al navegar
                  if (window.innerWidth < 1024 && onClose) {
                    onClose();
                  }
                }}
              >
                <span className="nav-icon">{item.icon}</span>
                {!collapsed && <span className="nav-label">{item.label}</span>}
              </NavLink>
            );
          })}
        </nav>

        {/* User Footer */}
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {user?.nombre?.charAt(0).toUpperCase() || 'U'}
            </div>
            {!collapsed && (
              <div className="user-details">
                <div className="user-name">{user?.nombre || 'Usuario'}</div>
                <div className="user-role">{user?.tipo || 'User'}</div>
              </div>
            )}
          </div>
          <button 
            className="logout-btn" 
            onClick={handleLogout}
            title="Cerrar Sesión"
          >
            🚪
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
